import React, { useCallback, useEffect, useRef, useState } from 'react'
import SignatureCanvas from 'react-signature-canvas'

export default function SignaturePad(props) {
  const ref = useRef()
  const [buffer, setBuffer] = useState([props.signature])
  const [signature, setSignature] = useState(props.signature)

  useEffect(() => {
    if (ref.current && props.signature?.includes('png')) {
      ref.current.fromDataURL(props.signature)
    }
  }, [props.signature, ref])

  function reset(e) {
    e.preventDefault()
    setBuffer([])
    ref.current?.clear()
  }

  function undo(e) {
    e.preventDefault()
    const [_, previous, ...rest] = buffer

    if (previous) {
      ref.current.clear()
      ref.current.fromDataURL(previous)
      setBuffer([previous, ...rest].filter(Boolean))
    } else {
      ref.current.clear()
    }
  }

  const doneSigning = useCallback(() => {
    const blob = ref.current.toDataURL('image/png')
    setSignature(blob)
    setBuffer([blob, ...buffer])
  }, [props.signature, signature, buffer])

  return (
    <>
      <input
        type="hidden"
        name={`prescription_template[signature]`}
        value={signature ?? ''}
      />

      <div className="editor">
        <SignatureCanvas
          canvasProps={{ className: 'signature-pad' }}
          onEnd={doneSigning}
          ref={ref}
        />
        <div className="toolbar">
          <button onClick={reset}>
            <i className="fal fa-trash"></i>
          </button>

          <button onClick={undo}>
            <i className="fal fa-undo"></i>
          </button>
        </div>
      </div>
      <p>Use seu mouse ou trackpad para desenhar sua assinatura</p>
    </>
  )
}
